import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  addInitialcart,
  addSelectedBook,
  addTocart,
  addTofavorite,
  deleteItem,
  deletefavorite,
  resetCart,
  resetfavorite,
  removeUser,
  updateSelectedVariantProduct,
  resetSelectedVariantProduct,
  updateSelectedVariants,
  resetSelectedVariants,
} from "../redux/productSlice";
import axios from "axios";
import bookPlaceHolder from "../../assets/bookPlaceHolder.png";
import { useNavigate } from "react-router-dom";

const AuthContext = React.createContext({
  selectedcurrency: {},
  setselectedcurrency: () => {},
  isPopupCartOpen: {},
  setisPopupCartOpen: () => {},
  addedBookCart: {},
  setaddedBookCart: () => {},
  currencyRate: {},
  setcurrencyRate: () => {},
  selectedlanguage: {},
  setselectedlanguage: () => {},
  isLoading: {},
  reviewData: {},
  setReviewData: () => {},
  bookDetails: {},
  setbookDetails: () => {},
  returnData: {},
  setReturnData: () => {},
  editreturnData: {},
  seteditReturnData: () => {},
  addToCart: () => {},
  addToCartWithQty: () => {},
  deleteFromcart: () => {},
  addToFavorite: () => {},
  deleteFavorite: () => {},
  articles: [],
  categories: [],
  setArticles: () => {},
  fetchArticles: () => {},
  fetchCategories: () => {},
  companySettings: [],
  setCompanySettings: () => {},
  fetchCompanySettings: () => {},
  collections: [],
  setCollections: () => {},
  fetchCollections: () => {},
  collaborators: [],
  setCollaborators: () => {},
  fetchCollaborators: () => {},
  fetchfavandcartSettings: () => {},

  countries: [],
  setCountries: () => {},

  societeConfig: [],
  setSocieteConfig: () => {},

  isCompareEnabled: [],
  setIsCompareEnabled: () => {},

  checkoutError: {},
  setCheckoutError: () => {},

  publishers: [],
  setPublishers: () => {},
});

export const AuthContextProvider = (props) => {
  const [selectedcurrency, setselectedcurrency] = useState("eur");
  const [isPopupCartOpen, setisPopupCartOpen] = useState(false);
  const [addedBookCart, setaddedBookCart] = useState({});
  const [currencyRate, setcurrencyRate] = useState(null);
  const [selectedlanguage, setselectedlanguage] = useState("fr");
  const [reviewData, setReviewData] = useState([]);
  const [bookDetails, setbookDetails] = useState({});
  const [returnData, setReturnData] = useState([]);
  const [editreturnData, seteditReturnData] = useState({});
  const [articles, setArticles] = useState([]);
  const [companySettings, setCompanySettings] = useState([]);
  const [categories, setCategories] = useState([]);
  const [collaborators, setCollaborators] = useState([]);
  const [collections, setCollections] = useState([]);
  const [societeConfig, setSocieteConfig] = useState([]);
  const [countries, setCountries] = useState([]);
  const [checkoutError, setCheckoutError] = useState(null);
  const [publishers, setPublishers] = useState([]);
  const [articleFamilleParents, setArticleFamilleParents] = useState([]);
  const [articleFamille, setArticleFamille] = useState([]);
  const [addtocartPopupOpen, setaddtocartPopupOpen] = useState(false);
  const [addtocartPopupId, setaddtocartPopupId] = useState(null);
  const dispatch = useDispatch();
  const productData = useSelector((state) => state.products.productData);
  const favorites = useSelector((state) => state.products.favorites);
  const user = useSelector((state) => state.products.userInfo);
  const language = useSelector(
    (state) => state.products.selectedLanguage[0].Language
  );
  const [collaboratorsTypes, setCollaboratorsTypes] = useState([]);
  const SelectedCategoryId = useSelector((state) => state.products.selectedCategoryId);
  const [articleFamilleId, setarticleFamilleId] = useState(SelectedCategoryId || null);
  React.useEffect(() => {
            setarticleFamilleId(SelectedCategoryId || null);
    }, [SelectedCategoryId]);
  const [isLoading, setIsLoading] = useState(false);
  const [isCompareEnabled, setIsCompareEnabled] = useState(true);

  const token = sessionStorage.getItem("token");

  const setReviewDatahandler = (reviewData) => {
    setReviewData(reviewData);
  };

  const setBookDetailshandler = (reviewData) => {
    setbookDetails(reviewData);
    dispatch(addSelectedBook(reviewData));
  };

  const addToCarthandler = async (propss) => {
    if (isLoading) {
      return;
    }

    const props = propss.props ? propss.props : propss;
    if (!props?.id) return;

    const hasVariantProduct =
      (props?.variant_product?.variant_product_combine_fields?.length || 0) > 0 &&
      (props?.variant_product?.variants?.length || 0) > 0;
    const hasResolvedVariantProduct = Boolean(props?.selected_variant_product?.id);

    if (hasVariantProduct && !hasResolvedVariantProduct) {
      setaddtocartPopupId(props?.id || null);
      setaddtocartPopupOpen(true);
      return;
    }

    setIsLoading(true);

    const variantProduct = props?.selected_variant_product?.id ? props.selected_variant_product : null;
    const articlePayload = variantProduct
      ? {
          ...props,
          id: variantProduct.id,
          designation: variantProduct.designation || props.designation,
          _prix_public_ttc: variantProduct._prix_public_ttc ?? props._prix_public_ttc,
          _qte_a_terme_calcule: variantProduct._qte_a_terme_calcule,
          articleimage:
            variantProduct.articleimage?.length > 0 ? variantProduct.articleimage : props.articleimage,
          _code_barre: variantProduct._code_barre || props._code_barre,
        }
      : props;

    const data = {
      article_id: articlePayload.id,
      user_id: user?.id || null,
      quantity: Number(props.items_quantity ?? props.quantity ?? 1),
      article: articlePayload,
      cart_items_variants: props?.selectedvariants,
      selected_variant_product_values: props?.selected_variant_product_values,
      selected_variant_product: variantProduct,
      parent_product: hasVariantProduct ? props : undefined,
      article_variant_combination: props?.article_variant_combination,
      b_usr_article_variant_combination_id: props?.article_variant_combination?.id
    };
    try {
      // Find if product already exists in the cart (match by id and variants)
      let userexistingarticle = null;
      if (data.article_variant_combination) {
        userexistingarticle = productData.find(item => 
          item?._id === data.article_id && item.article_variant_combination?.id === data.b_usr_article_variant_combination_id
        );
      } else {
        userexistingarticle = productData.find(item => item?._id === data.article_id);
      }

      // Helper to get max allowed quantity
      const getMaxQty = () => {
        if (props?.article_variant_combination?.id) {
          return props.article_variant_combination?.quantity;
        }
        if (variantProduct) {
          return variantProduct._qte_a_terme_calcule;
        }
        return props?._qte_a_terme_calcule || props?.quantity;
      };

      // Calculate new quantity
      let newQty;
      if (userexistingarticle) {
        newQty = userexistingarticle.quantity + (props.items_quantity ? props.items_quantity : 1);
        const maxQty = getMaxQty();
        if (maxQty && newQty > maxQty) newQty = maxQty;
      } else {
        newQty = data.quantity || 1;
        const maxQty = getMaxQty();
        if (maxQty && newQty > maxQty) newQty = maxQty;
      }
      if (user?.id) {
        if (userexistingarticle) {
          await axios.put(
            `${process.env.REACT_APP_TESTING_API}/cart/${userexistingarticle.cart_id}`,
            { quantity: newQty }
          );
          dispatch(addTocart({
            ...userexistingarticle,
            quantity: newQty
          }));
        } else {
          const response = await axios.post(
            `${process.env.REACT_APP_TESTING_API}/cart?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`,
            {
              ...articlePayload,
              article_id: articlePayload.id,
              quantity: newQty,
              user_id: user.id,
              b_usr_article_variant_combination_id: props?.article_variant_combination?.id,
            }
          );
          dispatch(addTocart({ ...response.data.data, article_variant_combination: props.article_variant_combination }));
        }
        setaddtocartPopupOpen(false);
        } else {
        // Guest user: allow adding to local redux cart without requiring login
        if (userexistingarticle) {
          // update quantity for existing local cart item
          dispatch(addTocart({
            ...userexistingarticle,
            quantity: newQty,
          }));
          
        } else {
          // add new local cart item
          console.log("Adding new item to local cart");
          
          const localId = `local-${Date.now()}`;

          // Helper to normalize incoming cart_items_variants which may be an object keyed by variant ids
          const normalizeCartItemsVariants = (input, cartId) => {
            if (!input) return [];
            // If already an array, try to keep it
            if (Array.isArray(input)) return input;
            // input is object like { "22": { id:68,... }, "23": { id:72,... } }
            const out = [];
            Object.keys(input).forEach((variantKey, index) => {
              const v = input[variantKey];
              // For compatibility, compute a synthetic id for the mapping entry
              const syntheticId = Math.floor(Date.now() / 1000) + index;
              out.push({
                id: syntheticId,
                cart_id: cartId,
                article_variant_id: Number(v.b_usr_article_variant_id || variantKey),
                variant_item_id: Number(v.id || v.b_usr_article_variant_item_id || v.b_usr_article_variant_item_id),
                created_at: new Date().toISOString(),
                updated_at: new Date().toISOString(),
                articlevariant: {
                  id: Number(v.b_usr_article_variant_id || variantKey),
                  b_usr_article_id: props.id,
                  nom: v.nom || (v.value ? 'Variant' : ''),
                  is_mandatory: !!v.is_mandatory,
                },
                variantitem: {
                  id: Number(v.id || v.b_usr_article_variant_item_id || v.b_usr_article_variant_item_id),
                  b_usr_article_variant_id: Number(v.b_usr_article_variant_id || variantKey),
                  value: v.value || '',
                  image: v.image || '',
                  quantity: v.quantity || 0,
                  squ: v.squ || '0',
                  price: v.price || '0',
                }
              });
            });
            return out;
          };

          const normalizedVariants = normalizeCartItemsVariants(data?.cart_items_variants, localId);

          const localPayload = {
            _id: props.id ?? localId,
            id: localId,
            title: props.designation,
            author: props.dc_auteur,
            image: props.articleimage?.[0]?.link ? props.articleimage[0].link : bookPlaceHolder,
            price: props.prixpublic,
            _qte_a_terme_calcule: props._qte_a_terme_calcule,
            discount: props.discount,
            quantity: newQty,
            description: props.descriptif,
            weight: props._poids_net,
            cart_id: localId,
            price_ttc: props._prix_public_ttc,
            article_stock: props.article_stock,
            cart_items_variants: normalizedVariants,
            localcart_items_variants: data?.cart_items_variants,
            article_variant_combination: props.article_variant_combination,
          };
          
          dispatch(addTocart(localPayload));
          // Show confirmation for guest local add
          // setisPopupCartOpen(true);
          setaddedBookCart(props);
          toast.success(`${language === 'eng' ? "Item is added to Cart" : "L'article est ajouté au panier"}`, {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            theme: "colored",
          });
        }
        setaddtocartPopupOpen(false);
      }
      await fetchfavandcartSettings();
    } catch (error) {
      console.error("Error adding to cart:", error);
      toast.error("Failed to add item to cart.", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const addToCartWithQtyhandler = async (props) => {
    // console.log(props)
    const maxQuantity = props._qte_a_terme_calcule;
    const item = productData.find(item => item._id === props.id);
    console.log(props);
     if (!item) {
     try {
      setIsLoading(true);
      const response = await axios.post(`${process.env.REACT_APP_TESTING_API}/cart?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`, {
        user_id: user.id,
        article_id: props.id,
        quantity: props.quantity,
        selectedvariants: Object.values(props.selectedvariants),
        article_variant_combination: props?.article_variant_combination
      });
      dispatch(addTocart({
        _id: props.id,
        title: props.designation,
        author: props.dc_auteur,
        image: props.image,
        price: props.prixpublic,
        _qte_a_terme_calcule: props._qte_a_terme_calcule,
        discount: props.discount,
        quantity: props.quantity,
        description: props.descriptif,
        weight: props._poids_net,
        cart_id: response.data.data.id,
        price_ttc: props._prix_public_ttc,
        article_stock: props.article_stock,
        article_variant_combination: props?.article_variant_combination
      }));

      setisPopupCartOpen(true);
      setaddedBookCart(props);
      toast.success(`${language === 'eng' ? "Product is added to Cart" : "Le produit est ajouté au panier"}`, {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
    } catch (error) {
      console.error("Error adding to cart:", error);
      toast.error(`${language === 'eng' ? "Failed to add item to cart." : "Échec de l'ajout d'un article au panier."}`, {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
      // console.log(error)
    } finally{
      setIsLoading(false);
    };
     } else {
      const newQuantity = Number(item.quantity * 1) + Number(props.quantity * 1);
      const newQuantityMax = Number(maxQuantity) - Number(item.quantity * 1);
      // console.log("item.quantity", item.quantity)
      // console.log("props.quantity", props.quantity)
      // console.log("newQuantity", newQuantity)
      setIsLoading(true);
      if (Number(newQuantity) > Number(maxQuantity)) {

        axios.put(`${process.env.REACT_APP_TESTING_API}/cart/${item.cart_id}`, {
          quantity: Number(maxQuantity).toFixed(0),
          })
          .then((response) => {
              // console.log("PUT request successful:", response.data);
              dispatch(addTocart({
                  _id: props.id,
                  quantity: Number(newQuantityMax).toFixed(0),
                }))
                setisPopupCartOpen(true);
                setaddedBookCart(props);
                setIsLoading(false);
                toast.success(`${language === 'eng' ? "Product is added to Cart" : "Le produit est ajouté au panier"}`, {
                  position: "top-right",
                  autoClose: 1500,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: 0,
                  theme: "colored",
                });
          })
          .catch((error) => {
              // console.error("Error in PUT request:", error);
              setIsLoading(false);
              toast.error(`${language === 'eng' ? "Failed to add item to cart." : "Échec de l'ajout d'un article au panier."}`, {
                position: "top-right",
                autoClose: 1500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: 0,
                theme: "colored",
              });
          });
      } else {

        axios.put(`${process.env.REACT_APP_TESTING_API}/cart/${item.cart_id}`, {
          quantity: newQuantity,
          })
          .then((response) => {
              // console.log("PUT request successful:", response.data);
              dispatch(addTocart({
                  _id: props.id,
                  quantity: props.quantity,
                }))
                setisPopupCartOpen(true);
                setaddedBookCart(props);
                setIsLoading(false);
                toast.success(`${language === 'eng' ? "Product is added to Cart" : "Le produit est ajouté au panier"}`, {
                  position: "top-right",
                  autoClose: 1500,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: 0,
                  theme: "colored",
                });
          })
          .catch((error) => {
              // console.error("Error in PUT request:", error);
              setIsLoading(false);
              toast.error(`${language === 'eng' ? "Failed to add item to cart." : "Échec de l'ajout d'un article au panier."}`, {
                position: "top-right",
                autoClose: 1500,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: 0,
                theme: "colored",
              });
          });
      }
      
    }
  }

  const deleteFromcarthandler = async (props) => {
    const variantId = props?.article_variant_combination?.id;
    const productId = props?._id;
    let item;
    if (variantId) {
      item = productData.find((item) => variantId === item.article_variant_combination?.id && productId === item._id);
    } else {
      item = productData.find((item) => item._id === productId);
    }
    if (user?.id) {
      axios
        .delete(`${process.env.REACT_APP_TESTING_API}/cart/${item.cart_id}`)
        .then(() => {
          // console.log("delete request successful:");
          dispatch(deleteItem(item));
          toast.success(
            `${language === "eng" ? "Product is removed" : "Le produit est retiré"}`,
            {
              position: "top-right",
              autoClose: 1500,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
              theme: "colored",
            }
          );
        })
        .catch((error) => {
          // console.error("Error in delete request:", error);
          toast.error(
            `${
              language === "eng"
                ? "Failed to delete item from cart."
                : "Échec de la suppression de l'article du panier."
            }`,
            {
              position: "top-right",
              autoClose: 1500,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
              theme: "colored",
            }
          );
        });
    } else {
      dispatch(deleteItem(item));
      toast.success(
        `${language === "eng" ? "Product is removed" : "Le produit est retiré"}`,
        {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
          theme: "colored",
        }
      );
    }
  };

  const fetchArticles = async () => {
    try {
      let articleFamilleIdParam = '';
      if (SelectedCategoryId && SelectedCategoryId !== 'null') {
        articleFamilleIdParam = `&articlefamilleparent_id=${SelectedCategoryId}`;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_TESTING_API}/articles?ecom_type=${process.env.REACT_APP_ECOM_TYPE}${articleFamilleIdParam}`
      );

      setArticles(response.data.data);
    } catch (error) {
      // console.error('Error fetching articles:', error);
    }
  };

  
  const fetchArticleFamilleParents = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_TESTING_API}/article-famille-parents?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`
      );

      setArticleFamilleParents(response.data);
    } catch (error) {
      // console.error('Error fetching articles:', error);
    }
  };

  
  const fetchArticleFamille = async () => {
    try {
      let articleFamilleIdParam = '';
      if (SelectedCategoryId && SelectedCategoryId !== 'null') {
        articleFamilleIdParam = `&articlefamilleparent_id=${SelectedCategoryId}`;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_TESTING_API}/article-famille?ecom_type=${process.env.REACT_APP_ECOM_TYPE}${articleFamilleIdParam}`
      );

      setArticleFamille(response.data);
    } catch (error) {
      // console.error('Error fetching articles:', error);
    }
  };

  const fetchCountries = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_TESTING_API}/countries?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`
      );
      setCountries(response.data);
    } catch (error) {
      // console.error('Error fetching countries:', error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_TESTING_API}/categories?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`
      );
      const sorteddata = [...response.data]
        .filter((itt) => itt?._nom !== "")
        .sort((a, b) => a._nom.localeCompare(b._nom));
      setCategories(sorteddata);
    } catch (error) {
      // console.error('Error fetching categories:', error);
    }
  };

  
    const fetchCollabTypes = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_TESTING_API}/collaborators/types?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`);
        setCollaboratorsTypes(response.data);
      } catch (error) {
        // console.error('Error fetching collaborator types:', error);
      }
    };

  const fetchCollaborators = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_TESTING_API}/collaborators?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`
      );
      const filteredData = response.data.filter((itt) => itt?.type?.id !== 25);
      const sorteddata = [...filteredData].sort((a, b) =>
        a._nom.localeCompare(b._nom)
      );
      setCollaborators(sorteddata);
    } catch (error) {
      // console.error('Error fetching collaborators:', error);
      // toast.error('Failed to fetch categories.');
    }
  };
  const fetchCollections = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_TESTING_API}/collections?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`
      );
      const sorteddata = [...response.data].sort((a, b) =>
        a.nom.localeCompare(b.nom)
      );
      setCollections(sorteddata);
    } catch (error) {
      // console.error('Error fetching collections:', error);
    }
  };

  const fetchPublishers = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_TESTING_API}/publishers?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`
      );
      const sorteddata = [...response.data].sort((a, b) =>
        a.title.localeCompare(b.title)
      );
      setPublishers(sorteddata);
    } catch (error) {
      // Handle error silently
    }
  };

  const fetchSocieteConfig = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_TESTING_API}/societe-config`
      );
      setSocieteConfig(response.data);
    } catch (error) {
      // console.error('Error fetching collections:', error);
    }
  };

  const fetchCompanySettings = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_TESTING_API}/company-settings?ecom_type=${process.env.REACT_APP_ECOM_TYPE}`
      );
      setCompanySettings(response.data.data);
      const compareSetting = response.data.data?.website_config?.find(
        (itt) => itt.lookup_config_type === 43
      )?.is_exist;
      setIsCompareEnabled(compareSetting);
      if (response.data.data?.usd_rate) {
        setcurrencyRate(response.data.data?.usd_rate);
      }
      localStorage.setItem("favIcon", response.data.data?.fav_icon);
    } catch (error) {
      // console.error('Error fetching articles:', error);
      // toast.error('Failed to fetch articles.');
    }
  };
  const fetchfavandcartSettings = async () => {
    if (user?.id) {
      try {
        const cartResponse = await axios.get(
          `${process.env.REACT_APP_TESTING_API}/users/${user.id}/cart`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include token in the headers
            },
          }
        );
        const userCart = cartResponse.data.data;
        dispatch(resetCart());
        userCart.forEach((cartItem) => {
          const article_id = cartItem.article_id;
          const foundBook = articles.find((book) => book.id === article_id);
            dispatch(addInitialcart({
              cart_id: cartItem.id,
              _id: cartItem.article.id,
              title: cartItem.article.designation,
              author: cartItem.article.dc_auteur,
              image: cartItem.article.articleimage[0]?.link ? cartItem.article.articleimage[0].link : bookPlaceHolder,
              price: cartItem.article.prixpublic,
              _qte_a_terme_calcule: cartItem.article?._qte_a_terme_calcule,
              discount: cartItem.discount,
              _code_barre: cartItem.article._code_barre,
              quantity: cartItem.quantity < cartItem.article?._qte_a_terme_calcule ? cartItem.quantity : Number(cartItem.article?._qte_a_terme_calcule).toFixed(0),
              description: cartItem.article.descriptif,
              weight: cartItem.article._poids_net,
              price_ttc: cartItem.article._prix_public_ttc,
              removed: cartItem.removed,
              article_stock: cartItem.article.article_stock,
              cart_items_variants: cartItem.cart_items_variants,
              article_variant_combination: cartItem.article_variant_combination,
              selected_variant_product_values: cartItem.selected_variant_product_values,
              selected_variant_product: cartItem.selected_variant_product,
              parent_product: cartItem.parent_product,
            }));
        });

        const favoriteResponse = await axios.get(
          `${process.env.REACT_APP_TESTING_API}/users/${user.id}/favorite`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include token in the headers
            },
          }
        );
        const favoriteCart = favoriteResponse.data.data; // Assuming cart data is returned in the response
        dispatch(resetfavorite());
        favoriteCart.forEach((favtItem) => {
          const article_id = favtItem.article_id;
          dispatch(
            addTofavorite({
              id: favtItem.id,
              _favid: favtItem.article?.id,
              favtitle: favtItem.article?.designation,
              favauthor: favtItem.article?.dc_auteur,
              favimage: favtItem.article?.articleimage[0]?.link
                ? favtItem.article?.articleimage[0].link
                : bookPlaceHolder,
              favprice: favtItem.article?.prixpublic,
              _qte_a_terme_calcule: favtItem.article?._qte_a_terme_calcule,
              favdescription: favtItem.article?.descriptif,
              _code_barre: favtItem.article?._code_barre,
              favquantity: 1,
              discount: favtItem.discount,
              weight: favtItem.article?._poids_net,
              price_ttc: favtItem.article?._prix_public_ttc,
              removed: favtItem.removed,
              article_stock: favtItem.article?.article_stock,
            })
          );
        });
      } catch (error) {
        // const errormsg = error.response.data.error;
        // console.error('Error in Login:', `${errormsg}`);
      }
    }
  };

  const FetchUserData = async () => {
    await fetchfavandcartSettings();
  };

  const checkUserLoggedIn = async () => {
    // Only check if user exists and has an ID
    
    const sessionEndedMsg = language === "eng"
      ? "Session ended, please login again."
      : "Session terminée, veuillez vous reconnecter.";

    if (!user?.id) {
      dispatch(removeUser());
      localStorage.removeItem("token");
      return { is_logged_in: false };
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_TESTING_API}/is-user-logged-in`,
        { user_id: user.id }
      );

      // If response indicates user is not logged in, remove user from state
      if (!response.data.is_logged_in) {
        dispatch(removeUser());
        localStorage.removeItem("token");
      toast.info(sessionEndedMsg, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
      } else {
        FetchUserData();
      }

      return response.data;
    } catch (error) {
      // If request fails (e.g., unauthorized), assume user is not logged in
      dispatch(removeUser());
      localStorage.removeItem("token");
      toast.info(sessionEndedMsg, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
      return { is_logged_in: false };
    }
  };

  useEffect(() => {
    fetchArticles();
    fetchArticleFamille();
  }, [articleFamilleId]);
  useEffect(() => {
    const initializeApp = async () => {
      fetchSocieteConfig();
      await checkUserLoggedIn();
      fetchArticles();
      fetchCategories();
      fetchCompanySettings();
      fetchCollabTypes();
      fetchCollaborators();
      fetchCollections();
      fetchCountries();
      fetchPublishers();
      fetchArticleFamilleParents();
      fetchArticleFamille();
    };

    initializeApp();
  }, []);

  const addToFavoritehandler = async (props) => {
    const item = favorites.find((item) => item._favid === props.id);
    if (!user?.id) {
      toast.error(
        `${
          language === "eng"
            ? "Please login to add to wishlist."
            : "Veuillez vous connecter pour ajouter à votre liste de souhaits."
        }`,
        {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
          theme: "colored",
        }
      );
    } else {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_TESTING_API}/favorites`,
          {
            user_id: user.id,
            article_id: props.id,
          }
        );
        dispatch(
          addTofavorite({
            id: response.data.data.id,
            _favid: props.id,
            favtitle: props.designation,
            favauthor: props.dc_auteur,
            favimage: props.articleimage[0]?.link
              ? props.articleimage[0].link
              : bookPlaceHolder,
            favprice: props.prixpublic,
            _qte_a_terme_calcule: props._qte_a_terme_calcule,
            _code_barre: props._code_barre,
            discount: props.discount,
            favquantity: 1,
            favdescription: props.descriptif,
            weight: props._poids_net,
            price_ttc: props._prix_public_ttc,
            article_stock: props.article_stock,
          })
        );

        toast.success(
          `${
            language === "eng"
              ? "Product is added to wishlist"
              : "Le produit est ajouté à la liste de souhaits "
          }`,
          {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            theme: "colored",
          }
        );
      } catch (error) {
        // console.error("Error adding to cart:", error);
        toast.error(
          `${
            language === "eng"
              ? "Failed to add item to wishlist."
              : "Échec de l'ajout d'un article à la liste de souhaits."
          }`,
          {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
            theme: "colored",
          }
        );
      }
    }
  };

  const deleteFavoritehandler = async (props) => {
    const item = favorites.find((item) => item._favid === props);
    // console.log(props)
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_TESTING_API}/favorites/${item.id}`
      );
      dispatch(deletefavorite(item.id));

      toast.success(
        `${
          language === "eng"
            ? "Product is removed from wishlist"
            : "Le produit est retiré de la liste de souhaits"
        }`,
        {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
          theme: "colored",
        }
      );
    } catch (error) {
      // console.error("Failed to remove book from wishlist:", error);
      toast.error(
        `${
          language === "eng"
            ? "Failed to remove product from wishlist."
            : "Le produit n'a pas été supprimé de la liste de souhaits."
        }`,
        {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
          theme: "colored",
        }
      );
    }
  };

  const seteditReturnDatahandler = (editreturnData) => {
    seteditReturnData(editreturnData);
  };

  const setReturnDatahandler = (returnData) => {
    setReturnData(returnData);
  };

  const setArticleshandler = (articles) => {
    setArticles(articles);
  };

  const setCompanySettingshandler = (articles) => {
    setCompanySettings(articles);
  };
  const contextValue = {
    selectedcurrency: selectedcurrency,
    currencyRate: currencyRate,
    isPopupCartOpen: isPopupCartOpen,
    addedBookCart: addedBookCart,
    selectedlanguage: selectedlanguage,
    reviewData: reviewData,
    bookDetails: bookDetails,
    returnData: returnData,
    editreturnData: editreturnData,
    isLoading: isLoading,
    articles: articles,
    categories: categories,
    companySettings: companySettings,
    fetchArticles: fetchArticles,
    fetchCompanySettings: fetchCompanySettings,
    fetchCategories: fetchCategories,
    setcurrencyRate: setcurrencyRate,
    setselectedcurrency: setselectedcurrency,
    setselectedlanguage: setselectedlanguage,
    setReviewData: setReviewDatahandler,
    setbookDetails: setBookDetailshandler,
    deleteFromcart: deleteFromcarthandler,
    addToCart: addToCarthandler,
    addToCartWithQty: addToCartWithQtyhandler,
    addToFavorite: addToFavoritehandler,
    deleteFavorite: deleteFavoritehandler,
    seteditReturnData: seteditReturnDatahandler,
    setReturnData: setReturnDatahandler,
    setArticles: setArticleshandler,
    setCompanySettings: setCompanySettingshandler,
    setisPopupCartOpen: setisPopupCartOpen,
    setaddedBookCart: setaddedBookCart,
    collaborators: collaborators,
    fetchCollaborators: fetchCollaborators,
    collections: collections,
    fetchCollections: fetchCollections,
    fetchfavandcartSettings: fetchfavandcartSettings,

    countries,

    societeConfig,

    checkoutError,
    setCheckoutError,

    isCompareEnabled,

    publishers,

    articleFamilleParents,
    articleFamille,

    addtocartPopupOpen,
    setaddtocartPopupOpen,
    addtocartPopupId,
    setaddtocartPopupId,


    collaboratorsTypes,
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
